import React from 'react';

import { TypographyTextProps } from '../../../helpers';
import { TextEmotion } from './styles';

// передаем в компонент color, а в emotion используем customColor
// потому что возникают проблемы с внутренними типами emotion
export interface ColorType {
  color?: string | false;
}

export const Text: React.FC<TypographyTextProps & ColorType> = props => {
  const { color, children, ...other } = props;

  return (
    <TextEmotion customColor={color} {...other}>
      {children}
    </TextEmotion>
  );
};
